<template>
  <div class="settings">
    <b-loading :loading="loading" v-if="loading"></b-loading>
    <form class="settings__form" v-else>
      <h2 class="title is-5">Kontaktdaten</h2>
      <div class="columns">
        <div class="column">
          <b-field>
            <template slot="label"
              >Name<span class="required">*</span></template
            >
            <b-input v-model="name" required />
          </b-field>
        </div>
        <div class="column">
          <b-field label="">
            <template slot="label">
              E-Mail<span class="required">*</span>
              <b-tooltip
                type="is-light"
                size="is-large"
                position="is-bottom"
                multilined
                label="Mit dieser E-Mail meldest du dich in deinem Konto an.
            Außerdem nutzen wir diese E-Mail zur allgemeinen Kommunikation und richten damit auf beim
 Erstellen eines neuen Servers ein Administrator-Konto ein."
              >
                <font-awesome-icon icon="question-circle"></font-awesome-icon>
              </b-tooltip>
            </template>
            <b-input v-model="email" type="email" required> </b-input>
          </b-field>
        </div>
        <div class="column"></div>
      </div>
      <div class="columns">
        <div class="column is-two-thirds">
          <div class="buttons">
            <b-button
              type="is-success"
              icon-left="save"
              expanded
              @click="saveUser"
              >Speichern</b-button
            >
          </div>
        </div>
        <div class="column"></div>
      </div>

      <hr />

      <h2 class="title is-5">Rechnungsdaten</h2>
      <div class="columns">
        <div class="column">
          <b-field>
            <template slot="label"
              >Rechnungsadresse<span class="required">*</span>
              <b-tooltip
                type="is-light"
                size="is-large"
                position="is-bottom"
                multilined
                label="Diese Adresse wird auf deiner Rechnung angegeben. Wenn du keinen Namen angibst, wird der Kontaktname von oben verwendet."
              >
                <font-awesome-icon
                  icon="question-circle"
                ></font-awesome-icon> </b-tooltip
            ></template>
            <b-input
              v-model="billingAddress"
              type="textarea"
              minlength="10"
              placeholder="Rechnungsadresse"
              required
            ></b-input>
          </b-field>
        </div>
        <div class="column">
          <b-field>
            <template slot="label"
              >Umsatzsteuer-ID
              <b-tooltip
                type="is-light"
                size="is-large"
                position="is-bottom"
                multilined
                label="Optional: Umsatzsteuer-ID für Unternehmer"
              >
                <font-awesome-icon
                  icon="question-circle"
                ></font-awesome-icon> </b-tooltip
            ></template>
            <b-input v-model="billingVatId" />
          </b-field>
          <b-field v-show="!usePrimaryEmailForBilling">
            <template slot="label"
              >Rechnungs-E-Mail
              <b-tooltip
                type="is-light"
                size="is-large"
                position="is-bottom"
                multilined
                :required="!usePrimaryEmailForBilling"
                label="Mit dieser E-Mail meldest du dich in deinem ConfCloud Konto an.
            Außerdem richten wir auf jedem deiner ConfCloud-Server beim
            Erstellen ein Administrator-Konto mit dieser E-Mail ein."
              >
                <font-awesome-icon
                  icon="question-circle"
                ></font-awesome-icon> </b-tooltip
            ></template>
            <b-input v-model="billingEmail"> </b-input>
          </b-field>
        </div>
        <div class="column"></div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <b-checkbox
              v-model="usePrimaryEmailForBilling"
              @input="toggleUsePrimaryEmailForBilling"
              >Rechnungen an meine Kontakt-E-Mail senden</b-checkbox
            >
          </div>
        </div>
        <div class="column"></div>
      </div>
      <div class="columns">
        <div class="column is-two-thirds">
          <div class="buttons">
            <b-button
              type="is-success"
              icon-left="save"
              expanded
              @click="saveBilling"
              >Speichern</b-button
            >
          </div>
        </div>
        <div class="column"></div>
      </div>

      <hr />

      <h3 class="title is-6">Auftragsverarbeitung</h3>
      <div class="columns">
        <div class="column">
          <div class="buttons">
            <b-button type="is-primary" icon-left="edit" expanded disabled
              >Auftragsverarbeitung</b-button
            >
          </div>
        </div>
        <div class="column"></div>
        <div class="column"></div>
      </div>

      <hr />

      <h3 class="title is-6">Passwort ändern</h3>
      <div class="columns">
        <div class="column">
          <div class="buttons">
            <b-button
              type="is-primary"
              icon-left="lock"
              expanded
              @click="isPasswordModalOpen = true"
              >Passwort ändern</b-button
            >
          </div>
        </div>
        <div class="column"></div>
        <div class="column"></div>
      </div>

      <hr />

      <h3 class="title is-6">Benutzerkonto löschen</h3>
      <div class="columns">
        <div class="column">
          <div class="buttons">
            <b-button
              type="is-danger"
              size="is-small"
              icon-left="trash"
              outlined
              expanded
              @click="requestDelete"
              >Benutzerkonto löschen</b-button
            >
          </div>
        </div>
        <div class="column"></div>
        <div class="column"></div>
      </div>
    </form>

    <b-modal
      :active.sync="isPasswordModalOpen"
      aria-modal
      aria-role="dialog"
      has-modal-card
      trap-focus
    >
      <form action="">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
            <p class="modal-card-title">Passwort ändern</p>
          </header>
          <section class="modal-card-body">
            <b-field label="Aktuelles Passwort">
              <b-input
                placeholder="Aktuelles Passwort"
                v-model="password.old"
                password-reveal
                type="password"
                required
              >
              </b-input>
            </b-field>
            <b-field label="Neues Passwort">
              <b-input
                placeholder="Neues Passwort"
                v-model="password.new"
                password-reveal
                type="password"
                required
              >
              </b-input>
            </b-field>
            <b-field label="Neues Passwort (wiederholen)">
              <b-input
                placeholder="Neues Passwort (wiederholen)"
                v-model="password.new_confirmation"
                password-reveal
                type="password"
                required
              >
              </b-input>
            </b-field>
          </section>
          <footer class="modal-card-foot">
            <b-button @click="isPasswordModalOpen = false">Abbrechen</b-button>
            <b-button type="is-primary" @click="changePassword"
              >Passwort ändern</b-button
            >
          </footer>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "DashboardSettings",
  data() {
    return {
      name: "",
      email: "",
      billingAddress: "",
      billingVatId: "",
      billingEmail: "",
      password: {
        old: "",
        new: "",
        new_confirmation: ""
      },
      loading: true,
      usePrimaryEmailForBilling: true,
      isPasswordModalOpen: false
    };
  },
  methods: {
    saveUser() {
      let data = {};

      if (this.name !== this.$store.state.user.name) data.name = this.name;
      if (this.email !== this.$store.state.user.email) data.email = this.email;

      this.$store.state.api.users
        .update(data)
        .then(response => {
          console.log(response);
          if (response.data.id) {
            this.$buefy.toast.open("Einstellungen gespeichert");
            this.getUser();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    saveBilling() {
      let data = {};

      if (
        !this.$store.state.user.profile ||
        this.billingAddress !== this.$store.state.user.profile.billing_address
      )
        data.billing_address = this.billingAddress;
      if (
        !this.$store.state.user.profile ||
        this.billingVatId !== this.$store.state.user.profile.billing_vat_id
      )
        data.billing_vat_id = this.billingVatId;
      if (
        !this.$store.state.user.profile ||
        this.billingEmail !== this.$store.state.user.profile.billing_email
      )
        data.billing_email = this.billingEmail;

      this.$store.state.api.users
        .profile(data)
        .then(response => {
          console.log(response);
          if (response.data.id) {
            this.$buefy.toast.open("Einstellungen gespeichert");
            this.getUser();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getUser() {
      this.$store.state.api.users
        .self()
        .then(response => {
          console.log(response.data);
          this.$store.commit("user", response.data);
          localStorage.setItem("autofill", this.$store.state.user.email);

          this.name = this.$store.state.user.name;
          this.email = this.$store.state.user.email;
          if (this.$store.state.user.profile)
            this.billingAddress = this.$store.state.user.profile.billing_address;
          if (this.$store.state.user.profile)
            this.billingVatId = this.$store.state.user.profile.billing_vat_id;
          if (this.$store.state.user.profile)
            this.billingEmail = this.$store.state.user.profile.billing_email;

          this.usePrimaryEmailForBilling = this.email === this.billingEmail;

          this.loading = false;
        })
        .catch(error => console.log(error));
    },
    changePassword() {
      this.$store.state.api.users
        .password(this.password)
        .then(response => {
          console.log(response.data);

          this.password = {
            old: "",
            new: "",
            new_confirmation: ""
          };

          this.$buefy.toast.open("Passwort gespeichert");

          this.isPasswordModalOpen = false;
        })
        .catch(error => console.log(error));
    },
    toggleUsePrimaryEmailForBilling(value) {
      if (value) {
        this.billingEmail = this.email;
      } else {
        this.billingEmail = "";
      }
    },
    requestDelete() {
      window.location.href = "mailto:info@confcloud.de";
    }
  },
  mounted() {
    this.getUser();
  }
};
</script>

<style scoped lang="scss">
.settings {
  &__form {
    //max-width: 20rem;
  }
}
</style>
